import { BaseTmdxDriveAffiliateGroundSchemaValues } from '@lp/features/RoutePlanner/components/RouteLegForm/validation';
import { useMemo } from 'react';
import { getGroundTripWarnings } from '@lp/features/RoutePlanner/utils';
import { parseZonedDateTime } from '@internationalized/date';
import { useWatchFields } from '@/hooks/useWatchFields';
import { useDriveTripQuery } from '@/queries/drive-service';
import { WarningsListBanner } from './WarningsListBanner';

type GroundTripValidationBannersProps = {
  isEditMode: boolean;
};

export const GroundTripValidationBanners = ({ isEditMode }: GroundTripValidationBannersProps) => {
  const { tripId, departureDateTime, arrivalDateTime, resources } =
    useWatchFields<BaseTmdxDriveAffiliateGroundSchemaValues>([
      'tripId',
      'arrivalDateTime',
      'departureDateTime',
      'resources',
    ] as const);

  const { data } = useDriveTripQuery(tripId);

  const warnings = useMemo(() => {
    if (!data) return [];

    const departureTime = parseZonedDateTime(departureDateTime).toAbsoluteString();
    const arrivalTime = parseZonedDateTime(arrivalDateTime).toAbsoluteString();

    return getGroundTripWarnings({ departureTime, arrivalTime, resources }, data, isEditMode);
  }, [data, departureDateTime, arrivalDateTime, resources, isEditMode]);

  return <WarningsListBanner messages={warnings} />;
};
